import React from 'react'
import { createRoot } from 'react-dom/client'
// antd 5 reaches into React internals for its static message/notification/modal
// APIs; the official patch keeps those working on React 19.
import '@ant-design/v5-patch-for-react-19'
import '@fontsource/sora/400.css'
import '@fontsource/sora/600.css'
import '@fontsource/sora/700.css'
import '@fontsource/ibm-plex-sans-arabic/400.css'
import '@fontsource/ibm-plex-sans-arabic/600.css'
import '@fontsource/ibm-plex-sans-arabic/700.css'
import '@fontsource/ibm-plex-mono/400.css'
import { App } from './App'
import { applyInitialDirection } from './providers/i18n-provider'

// Direction must be set before the first paint (docs/04 §7.1).
applyInitialDirection()

const container = document.getElementById('root')
if (!container) throw new Error('#root introuvable')

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
